<template>
  <div class="pdf-img-viewer">
    <div class="pdf-img-viewer__toolbar">
      <button
        class="pdf-img-viewer__open-btn"
        type="button"
        :disabled="!fileUrl"
        @click="openInNewPage"
      >
        在新页面打开文件
      </button>
    </div>

    <iframe :key="fileUrl" :src="fileUrl" width="100%" height="800px" frameborder="0"></iframe>
  </div>
</template>

<script>
import { appjs } from "@/utiljs/apputil";
export default {
  props: {
    fileName: {
      type: String
    },
    entrustNums: {
      type: Array,
      default: () => []
    },
    updatePrintInfoApi: {
      type: Function,
      default: null
    }
  },
  data () {
    return {
      weburl: '',
      //fileUrl: 'http://localhost:8080/pdfjs/web/viewer_print.html?file=/api/pdf/5f6d6138-fcba-47a9-84d9-e0c5dfeab3fa_068f0ea5-d0af-4307-83c2-187adbc245969.pdf'
      fileUrl: ''
    };
  },
  mounted () {
    if (this.fileName) {
      this.init();
    }
    // 监听来自 iframe 的打印事件
    window.addEventListener('message', this.handlePrintMessage);
  },
  beforeDestroy () {
    // 移除事件监听
    window.removeEventListener('message', this.handlePrintMessage);
  },
  watch: {
    fileName (newVal) {
      if (newVal) {
        this.init();
      }
    }
  },
  methods: {
    openInNewPage () {
      if (!this.fileUrl) return;
      window.open(this.fileUrl, "_blank", "noopener,noreferrer");
    },
    handlePrintMessage (event) {
      // 检查消息类型
      if (event.data && event.data.type === 'PDF_PRINT_TRIGGERED') {
        console.log('检测到打印事件:', event.data);
        // 调用打印通知方法
        this.notifyPrintToBackend();
      }
    },
    notifyPrintToBackend () {
      // 调用后端 API 通知报告已被打印
      console.log('准备通知后端,文件名:', this.fileName);
      console.log('委托编号列表:', this.entrustNums);

      // 如果没有传递 API 方法或没有委托编号,则不调用
      if (!this.updatePrintInfoApi || !this.entrustNums || this.entrustNums.length === 0) {
        console.log('未提供 API 方法或委托编号,跳过打印通知');
        return;
      }

      // 一次性调用 API,传递所有委托编号
      this.updatePrintInfoApi(this.entrustNums).then((data) => {
        console.log('批量更新打印信息成功:', data);
      }).catch((error) => {
        console.error('批量更新打印信息失败:', error);
      });
    },
    appendCacheBuster (url) {
      if (!url) return url;
      const separator = url.indexOf('?') >= 0 ? '&' : '?';
      return url + separator + '_t=' + Date.now();
    },
    buildPdfViewerUrl (fileParam) {
      return this.weburl + 'pdfjs/web/viewer_print.html?file=' + encodeURIComponent(this.appendCacheBuster(fileParam));
    },
    init () {
      this.weburl = window.location.href.replace("main", "")
      if (this.fileName.indexOf(".") == -1) {
        appjs.showErrorMsg("不存在的文件");
        this.fileUrl = this.weburl + 'pdfjs/photo.png';
        return;
      }
      if (this.fileName.lastIndexOf(".pdf") != -1) {
        this.viewPdf();
      } else if (this.fileName.lastIndexOf(".doc") != -1 || this.fileName.lastIndexOf(".xls") != -1) {
        this.viewOffice();
      } else {
        this.viewImage();
      }
    },
    viewOffice () {
      let params = {
        fileName: this.fileName
      }
      let loadel = appjs.loading("加载中")
      appjs.httpRequest('fileUpload/getFileToView', params).then((data) => {
        appjs.unloading(loadel);
        if (data.retCode && data.retCode != "ok") {
          appjs.showErrorMsg(data.retMsg);
        } else {
          var filename = this.fileName;
          var pdfname = filename.substring(0, filename.lastIndexOf(".")) + ".pdf";
          this.fileUrl = this.buildPdfViewerUrl('/api/pdf/' + pdfname);
        }
      }).catch((error) => {
        appjs.unloading(loadel);
        appjs.showErrorMsg("异常：" + error)
      })
    },
    viewPdf () {
      // 如果传入的是完整 URL，则直接使用该地址；否则走后端 /api/pdf/ 代理
      const isFullUrl = this.fileName && (this.fileName.startsWith('http://') || this.fileName.startsWith('https://'));
      const fileParam = isFullUrl ? this.fileName : '/api/pdf/' + this.fileName;
      this.fileUrl = this.buildPdfViewerUrl(fileParam);
    },
    viewImage () {
      this.fileUrl = this.appendCacheBuster('/api/imgs/' + this.fileName);
    }
  }
}
</script>

<style scoped>
.pdf-img-viewer {
  position: relative;
}

.pdf-img-viewer__toolbar {
  position: absolute;
  top: 5px;
  right: 12%;
  z-index: 2;
}

.pdf-img-viewer__open-btn {
  padding: 6px 10px;
  font-size: 12px;
  line-height: 1;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  background: #fff;
  color: #303133;
  cursor: pointer;
}

.pdf-img-viewer__open-btn:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.pdf-img-viewer__open-btn:hover:not(:disabled) {
  border-color: #c6e2ff;
  color: #409eff;
}
</style>
